import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class QuestionCollectionsOrganizations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'QuestionCollectionsOrganizations'
  // Define default properties here
  static instanceDefaults () {
    return {
      questionCollectionId: null,
      organizationId: null,
    }
  }
}
const servicePath = 'question-collections-organizations'
const servicePlugin = makeServicePlugin({
  Model: QuestionCollectionsOrganizations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
